import React, { useEffect } from 'react';
import HorizontalLoader from '../../components/HorizontalLoader';
import ENDPOINT from '../../constants/endpoints';
import withNetworkActions from '../../hocs/withNetworkActions';
import {useGrid} from '../../hooks/useGrid';
import PageLayout from '../../layouts/PageLayout';
import PeopleGrid from './components/PeopleGrid';
import './styles.css';

const PeopleYouMayKnow = props => {
  const {
    networkAction: { connect },
  } = props;

  const {
    actions,
    data: { rows, isFetching: gridIsFetching },
  } = useGrid(ENDPOINT.COLLECTION.PEOPLE_YMK);

  useEffect(() => {
    actions.fetch();
  }, []);

  const handleClickConnect = params => {
    connect(params).then(actions.fetch);
  };

  return (
    <PageLayout
      pageClass="people-page"
      pageTitle="People you may know"
      mainContent={
        <>
          <div className="horizontal-loader__container">
            {gridIsFetching && <HorizontalLoader />}
          </div>
          <PeopleGrid records={rows} onConnectHandler={handleClickConnect} />
        </>
      }
    />
  );
};
export default withNetworkActions(PeopleYouMayKnow);
